import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import stylez from './StockTable.module.css';
import EditStock from '../EditStock/EditStockModal';
import axiosInstance from '../../../Configuration/axiosInstance';
import { FaTrash } from "react-icons/fa";
import LoadingSpinner from '../../../Components/Shared/Loader/Loader';
import { MdOutlineHistory } from "react-icons/md";
import CommentsModal from '../../../Components/Shared/CommentsModal/CommentsModal';


const StockTable = (props) => {
  const { warehouses } = props;
  const { allStock, loading, dataChanged, setDataChanged } = props;
  const [show, setShow] = useState(false);
  const [stockId, setStockId] = useState(null);
  const [showComments,setShowComments]=useState(false);
  const [comments,setComments] = useState([]);

  const deleteStock = (id) => {
    axiosInstance.delete(`stockRoute/${id}`);
    setDataChanged(!dataChanged);
  };

  const handleEditClick = (id) => {
    setShow(true);
    setStockId(id);
  };
  const handleCommentsClick=(comments)=>{
    setComments(comments);
    setShowComments(true);
  }

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '300px',
          }}
        >
          <LoadingSpinner />
        </div>
      ) : (
        <div className={stylez.stockBody}>
                 {show && 
                          <EditStock
                            show={show}
                            stockId={stockId}
                            setShow={setShow}
                          />
                      }
                      {showComments && <CommentsModal comments={comments} show={showComments} setShow={setShowComments}/>}
          <table className={stylez.stockTable}>
            <thead className={stylez.customtblHeaders}>
              <tr>
                <th>Image</th>
                <th>Product</th>
                <th>Sku</th>
                {warehouses.map((i, index) => (
                  <th key={index}>{i.name} </th>
                ))}
                <th>Total Stock</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {allStock?.map((i, index) => {
                return (
                  <tr key={index}>
                    <td><img alt="productimage" src={i?.product?.imageUrl} className={stylez.img}/></td>
                    <td>{i?.product?.productName}</td>
                    <td>{i?.product?.sku}</td>
                    {i.warehouses.map((i, index) => (
                      <td key={index}>{i.quantity}</td>
                    ))}
                    <td>
                      {i.warehouses
                        .map((i) => i.quantity)
                        .reduce((acc, curr) => acc + curr, 0)}
                    </td>
                    <td>
                    <div className='actionButtons'>
                      <button
                        className='editBtn'
                        onClick={() => handleEditClick(i._id)}
                      >
                        Update Stock
                      </button>

                      <button 
                      onClick={()=>{handleCommentsClick(i?.comments)}}
                      style={{color:'white',backgroundColor:'black'}}>
                        <MdOutlineHistory size={18}/>
                      </button>
                      <button
                        className='deleteBtn'
                        onClick={() => {
                          window.confirm(
                            'Are you sure you want to delete this Stock?'
                          ) && deleteStock(i._id);
                        }}
                      >
                     <FaTrash />
                      </button>
                     
                      </div>
                    </td>
                    <td>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default StockTable;
